import { Page, settings } from '@desp-aas/desp-ui-fwk';
import Navigation from '../../components/Navigation/Navigation';
import './DocumentationPage.css';
import { IframePage } from '@desp-aas/desp-ui-fwk/src/components/IframePage/IframePage';

export function DocumentationPage() {
    return <IframePage
        src={settings.documentationUrl}
        title="Documentation"
        id="documentation-page"
        navigation={<Navigation/>}
    />
};
